export default __webpack_public_path__ + "static/layout-example-sideNav-dark-99ae3a986580c538490002b98e9638a5a5f6dca236032d13ba338fbdd7b7ac6d.png";